import getSize from './getSize';
export default (function () {
  var _getSize = getSize(),
      width = _getSize.width,
      height = _getSize.height;

  return {
    top: 0,
    right: width,
    bottom: height,
    left: 0,
    width: width,
    height: height
  };
});